goog.provide("shadow.js.shim.module$src$svg$wpp$content_actions$approval_svg$default");
shadow.js.shim.module$src$svg$wpp$content_actions$approval_svg$default = shadow.js.shim.module$src$svg$wpp$content_actions$approval_svg.default;
